export const FIFTEEN_MINUTES_IN_MILLISECONDS = 1000 * 60 * 15;
export const MIDWAY_ID_TOKEN = "midwayIdToken";
export const MIDWAY_AUTH_USERNAME = "midwayAuthUsername";
